import React from 'react';
interface PaxStatementBookingSummaryProps {
  booking: {
    bookingRef: string;
    productName: string;
    tourCode: string;
    departure: string;
    return: string;
    bookingDate: string;
    bookingStaff: string;
    bookingStaffEmail: string;
    paymentReceived: number;
    totalAmount: number;
    balanceDueDate: string;
    currency: string;
  };
}
export function PaxStatementBookingSummary({
  booking
}: PaxStatementBookingSummaryProps) {
  const formatCurrency = (amount: number) => {
    return `${booking.currency} ${amount.toFixed(2)}`;
  };
  return <div className="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-5" data-id="element-656">
      <div className="space-y-3" data-id="element-657">
        {/* Row 1 */}
        <div className="grid grid-cols-4 gap-x-6 gap-y-2" data-id="element-658">
          <div data-id="element-659">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-660">
              Booking Ref:
            </p>
            <p className="text-sm font-bold text-neutral-900" data-id="element-661">
              {booking.bookingRef}
            </p>
          </div>
          <div data-id="element-662">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-663">
              Product Name:
            </p>
            <p className="text-sm font-semibold text-neutral-900" data-id="element-664">
              {booking.productName}
            </p>
          </div>
          <div data-id="element-665">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-666">
              Tour Code:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-667">{booking.tourCode}</p>
          </div>
          <div data-id="element-668">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-669">
              Travel Dates:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-670">
              {booking.departure} - {booking.return}
            </p>
          </div>
        </div>

        <div className="h-px bg-blue-200" data-id="element-671" />

        {/* Row 2 */}
        <div className="grid grid-cols-4 gap-x-6 gap-y-2" data-id="element-672">
          <div data-id="element-673">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-674">
              Booking Date:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-675">{booking.bookingDate}</p>
          </div>
          <div data-id="element-676">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-677">
              Booking Staff:
            </p>
            <p className="text-sm font-semibold text-neutral-900" data-id="element-678">
              {booking.bookingStaff}
            </p>
            <p className="text-xs text-neutral-600 mt-0.5" data-id="element-679">
              {booking.bookingStaffEmail}
            </p>
          </div>
          <div data-id="element-680">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-681">
              Payment:
            </p>
            <p className="text-sm text-neutral-900" data-id="element-682">
              {formatCurrency(booking.paymentReceived)} /{' '}
              {formatCurrency(booking.totalAmount)}
            </p>
          </div>
          <div data-id="element-683">
            <p className="text-xs font-semibold text-neutral-600 uppercase" data-id="element-684">
              Balance Due Date:
            </p>
            <p className="text-sm font-semibold text-red-600" data-id="element-685">
              {booking.balanceDueDate}
            </p>
          </div>
        </div>
      </div>
    </div>;
}